import React from 'react';

import { GenericPageLayoutWrapperSize } from './wrapper/GenericPageLayoutWrapper';

export interface ContextValue {
  wrapperSize?: GenericPageLayoutWrapperSize,
}

export default React.createContext<ContextValue>({});
